export enum EventTypeEnum {
  DataEntryCreated = 0,
  DataEntryUpdated = 1,
  DataEntryArchived = 2,
  WorkflowActionExecuted = 3,
  WorkflowStepReached = 4,
  WorkflowStepExited = 5,
  Timer = 6,
  CustomEvent = 7,
  ReactionSucceeded = 8,
  FileGenerated = 9,
  ZapierEvent = 20,
  SlaTimeExceeded = 100,
}
